<template>
  <div class="gameplan">
    <ContentHeader path-set-type="append" :gameplan-nav="true" />
    <div class="content-wrapper" v-loading="loading">
      <el-row>
        <el-col :span="3"></el-col>
        <el-col :span="18"><ActivityManagementUnConfiguredItem/></el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { mapGetters,mapState } from 'vuex'
import gameplanApi from "@/api/gameplan";
import ContentHeader from '@/components/content-header'
import ActivityManagementUnConfiguredItem from './components/activity-management-un-configured-item.vue';
export default {
  name: 'activity-management',
  components: {
    ContentHeader,
    ActivityManagementUnConfiguredItem
  },
  data() {
    return {
      loading:false,
      dialogLoading:false,
      queryParams: {
        page: 1,
        pageSize: 5,
        queryCondition:'03,05',
        prNumber: '', // PR编码
        prName:'', // PR名称

        brandCode: '', // 选择品牌
      },
      searchForm: {
        prId: '', // PR编码
        prName: '', // PR名称
        activityName: '', // 活动名称
        selectBrand: '', // 选择品牌
        selectChannel: '', // 选择渠道
      },
      btmpBrandDTOList:[],
      prList:[],
      themeList:[],
      total:0,
      dialog:false,
      item:{}
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    ...mapState({
      gpThemeChannelMap:state=> state.base.gpThemeChannelMap,
    })
  },
  created() {
    this.getGameplanThemeUnconfiguredList()
    //this.getGameplanConfigFull()
    this.getGameplanConfigIgniteOptions()
    this.getGameplanConfigByChannel()
    this.getGamepalnBrandquery()
    this.getGameplanThemeList()
  },
  methods: {
    async getGameplanThemeUnconfiguredList() {
      this.loading = true
      const { data } = await gameplanApi.getGameplanThemeUnconfiguredList(this.queryParams);
      if (data.resultCode === "0") {
        this.prList = data.resultData?.prList || [];
        //this.total = data.resultData.pageInfo.totalCounts
      }
      this.loading = false
    },
    async getGameplanThemeList(page,pageSize) {
      this.dialogLoading = true
      page?this.queryParams.page=page:''
      pageSize?this.queryParams.pageSize=pageSize:''
      const { data } = await gameplanApi.getGameplanThemeList(this.queryParams);
      if (data.resultCode === "0") {
        this.themeList = data.resultData?.themeList || [];
        this.total = data.resultData.pageInfo.totalCounts
      }
      this.dialogLoading = false
    },
    async getGamepalnBrandquery() {
      const { data } = await gameplanApi.getGamepalnBrandquery();
      if (data.resultCode === "0") {
        this.btmpBrandDTOList = data.resultData?.btmpBrandDTOList || [];
      }
    },
    async getGameplanConfigIgniteOptions() {
      const { data } = await gameplanApi.getGameplanConfigIgniteOptions();
      if (data.resultCode === "0") {
        this.igniteOptions = data.resultData?.igniteOptions || {};
      }
    },
    async getGameplanConfigByChannel() {
      let params ={
        channelCode:'01'
      }
      const { data } = await gameplanApi.getGameplanConfigByChannel(params);
      if (data.resultCode === "0") {
        //this.igniteOptions = data.resultData?.igniteOptions || {};
      }
    },
    async getGameplanConfigFull() {
      const { data } = await gameplanApi.getGameplanConfigFull();
      if (data.resultCode === "0") {
        this.fullConfig = data.resultData?.fullConfig || [];
        this.assignBuList = data.resultData?.assignBuList || []
        //this.total = data.resultData.pageInfo.totalCounts
      }
    },
    handleChoose(prName,brandName,subBrandName,prNumber){
      this.item = {
        prName,brandName,subBrandName,prNumber
      }
      this.dialog = true
    },
    getThemeChannels(themeChannels){
      let result = ''
      for(let item of themeChannels){
        result+=item.themeChannelEnName + '、'
      }
      return result.substr(0, result.length - 1);
    },
    handleCurrentChange(val) {
      this.queryParams.page = val
      this.getGameplanThemeList()
    },
    handleSizeChange (val) {
      this.queryParams.pageSize = val
      this.getGameplanThemeList()
    },
    resetForm() {
      this.$refs.searchForm.resetFields();
      this.getGameplanThemeUnconfiguredList()
    },
    gotoWeb(prName,brand,subBrand,prNumber,themeId,isHistory) {
      this.$router.push({ path:'/gameplan/activity-configure-hq', query:{prName,brand,subBrand,prNumber,themeId,isHistory}})
    },
    gotoConfig(themeId){
      this.$router.push({ path:'/gameplan/activity-configure-hq', query:{prName:this.item.prName,brand:this.item.brandName,subBrand:this.item.subBrandName,prNumber:this.item.prNumber,themeId,isHistory:true}})
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-pagination{
  text-align: center;
  margin-top: 20px;
}
.is-hover-shadow:hover {
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
}

.trade-nav-panel {
  width: 80%;
  margin: 0 auto;
  background: $base-white;

  //   .el-menu-item:last-child{
  //     border-bottom: 0;
  //   }
  ::v-deep .el-card__header {
    height: 70px;
    line-height: 35px;
  }

  ::v-deep .el-card__body {
    padding: 0;
  }

  .panel-header {
    font-size: 16px;
    font-weight: 700;
    color: #CD1231;
  }

  ::v-deep .el-menu {
    border-right: 0;
  }

  ::v-deep .el-menu-item {
    border-bottom: 1px solid $base-grey5;
  }

  ::v-deep .el-menu-item.is-active {
    color: $base-red;
  }
}
.content-wrapper {
  min-height: calc(100vh - 320px) !important;
  font-family: SourceHanSansSC-regular;
  //   .content-left,
  .content-right {
    height: 100%;
    box-sizing: border-box;
    a {
      text-decoration: none;
      color: #000;
    }

    .search {
      display: flex;
      justify-content: space-between;
      width: 100%;

      .item {
        width: 120px;
      }
      .item-btn {
        margin-left: 30px;
      }
    }

    .pagination {
      position: relative;
      bottom: 0;
    }
  }
.pagination .el-pagination {
  text-align: center;
}
  .content-left {
    padding-right: $content-middle;
  }
}

.pr_item{
  ::v-deep .el-card__body{
      padding: 15px;
    }
}

.block{
  //margin-top: 20px;
  //background-color: rgba(0, 0, 0, 1);
  width: 100%;
  height: 30px;
}
.trade-nav-panel-sp{
  margin-top: 30px;
}
.no_data{
  text-align: center;
  padding: 100px 0;
}
.border_grey{
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
}
</style>
